module.exports = __webpack_public_path__ + "img/anji.070d860d.png";